import { useRef } from 'react';
import { twMerge } from '@beerntea/pitcher-ui';
import gsap from 'gsap';

interface Props {
  onMouseEnter?: React.MouseEventHandler;
  onMouseLeave?: React.MouseEventHandler;
  onClick?: React.MouseEventHandler;
  label: React.ReactNode;
  subText: React.ReactNode;
  className?: string;
}

export function ListItem({ onMouseEnter, onMouseLeave, label, subText, className }: Props) {
  const labelRef = useRef<HTMLSpanElement>(null);
  const subTextRef = useRef<HTMLSpanElement>(null);

  const handleMouseEnter = (e: React.MouseEvent) => {
    if (labelRef.current) gsap.to(labelRef.current, { x: 16, duration: 0.3, ease: 'power2.out' });
    if (subTextRef.current) gsap.to(subTextRef.current, { x: -16, duration: 0.3, ease: 'power2.out' });

    onMouseEnter?.(e);
  };

  const handleMouseLeave = (e: React.MouseEvent) => {
    if (labelRef.current) gsap.to(labelRef.current, { x: 0, duration: 0.3, ease: 'power2.out' });
    if (subTextRef.current) gsap.to(subTextRef.current, { x: 0, duration: 0.3, ease: 'power2.out' });

    onMouseLeave?.(e);
  };

  return (
    <div
      className={twMerge(
        'tw-group tw-relative tw-flex tw-w-full tw-overflow-hidden tw-text-left tw-gap-2 tw-justify-between tw-border-b tw-border-b-light-gray/50 tw-border-l-[6px] tw-transition-colors tw-cursor-pointer',
        'tw-px-4 sm:tw-px-8 tw-border-l-transparent',
        'tw-text-white',
        'tw-items-start md:tw-items-center',
        'tw-py-4 xl:tw-py-6',
        className,
      )}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <span
        aria-hidden
        className="tw-pointer-events-none tw-absolute tw-inset-0 tw-bg-white tw-origin-top tw-scale-y-0 tw-transition-transform tw-duration-[1200ms] tw-ease-[cubic-bezier(.19,1,.22,1)] group-hover:tw-scale-y-100 group-hover:tw-origin-bottom"
      >
        &nbsp;
      </span>
      <span
        ref={labelRef}
        className="tw-relative tw-z-10 tw-transition-colors group-hover:tw-text-black"
      >
        {label}
      </span>
      <span
        ref={subTextRef}
        className="tw-relative tw-z-10 tw-transition-colors group-hover:tw-text-black"
      >
        {subText}
      </span>
    </div>
  );
}
